// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

export const vColorPaletteType = v.picklist([
  'CutFill',
  'Elevation',
  'PassCount',
  'CMV',
  'MDP',
  'Speed',
  'Temperature',
]);

/**
 * A single colour stop: a threshold on the data scale paired with an anchor colour.
 */
export const vColorStop = v.strictObject({
  value: v.optional(v.number()),
  color: v.nullish(v.string()),
});

/**
 * Base Response Dto containing the result from computing a measurement
 */
export const vComputeMeasurementResponseBase = v.strictObject({});

/**
 * Service status options
 */
export const vHealthStatus = v.picklist(['Unhealthy', 'Degraded', 'Healthy']);

/**
 * Represents a link.
 */
export const vLink = v.strictObject({
  href: v.nullish(v.string()),
});

/**
 * DTO for a line measurement's result
 */
export const vMeasurementLineResult = v.strictObject({
  length3d: v.nullish(v.number()),
  length2d: v.nullish(v.number()),
  verticalDifference: v.nullish(v.number()),
  verticalAverage: v.nullish(v.number()),
  verticalMin: v.nullish(v.number()),
  verticalMax: v.nullish(v.number()),
  slopeAndGradeDifference: v.nullish(v.number()),
  slopeAndGradeMin: v.nullish(v.number()),
  slopeAndGradeMax: v.nullish(v.number()),
  slopeAndGradeAverage: v.nullish(v.number()),
});

/**
 * DTO for the parameters used for calculating a Pass Count measurement.
 */
export const vMeasurementPassCountParameters = v.strictObject({
  targetPassCountMin: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  targetPassCountMax: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  filterUid: v.nullish(v.string()),
  vibeState: v.nullish(v.string()),
  travelDirection: v.nullish(v.string()),
  projectUid: v.nullish(v.pipe(v.string(), v.uuid())),
  accountUid: v.nullish(v.pipe(v.string(), v.uuid())),
  boundaryInclusive: v.nullish(v.record(v.string(), v.unknown())),
});

/**
 * DTO for the pass count target of a Pass Count measurement result.
 */
export const vMeasurementPassCountTarget = v.strictObject({
  minPassCountMachineTarget: v.nullish(v.number()),
  maxPassCountMachineTarget: v.nullish(v.number()),
  targetVaries: v.nullish(v.boolean()),
});

/**
 * DTO for the pass count details and summary data of a Pass Count measurement result.
 */
export const vMeasurementPassCountData = v.strictObject({
  percentEqualsTarget: v.nullish(v.number()),
  percentGreaterThanTarget: v.nullish(v.number()),
  percentLessThanTarget: v.nullish(v.number()),
  percents: v.nullish(v.array(v.number())),
  totalCoverageArea: v.nullish(v.number()),
  passCountTarget: v.optional(vMeasurementPassCountTarget),
  lastContributingCellPassDate: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * DTO for the result of a Pass Count measurement.
 */
export const vMeasurementPassCountResult = v.strictObject({
  passCountData: v.optional(vMeasurementPassCountData),
});

/**
 * Response Dto containing the result from computing a pass count measurement
 */
export const vComputeMeasurementPassCountResponse = v.intersect([
  vComputeMeasurementResponseBase,
  v.strictObject({
    result: v.optional(vMeasurementPassCountResult),
  }),
]);

/**
 * DTO for a Polyline measurement's result
 */
export const vMeasurementPolylineResult = v.strictObject({
  length3d: v.nullish(v.number()),
  length2d: v.nullish(v.number()),
  verticalDifference: v.nullish(v.number()),
  verticalAverage: v.nullish(v.number()),
  verticalMin: v.nullish(v.number()),
  verticalMax: v.nullish(v.number()),
  slopeAndGradeDifference: v.nullish(v.number()),
  slopeAndGradeMin: v.nullish(v.number()),
  slopeAndGradeMax: v.nullish(v.number()),
  slopeAndGradeAverage: v.nullish(v.number()),
});

export const vMeasurementType = v.picklist([
  'Point',
  'Line',
  'Polyline',
  'Volume',
  'Area',
  'Angle',
  'PassCount',
]);

/**
 * Base DTO for creating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vComputeMeasurementBase = v.strictObject({
  type: v.optional(vMeasurementType),
});

/**
 * Dto to compute a pass count measurement
 */
export const vComputeMeasurementPassCount = v.intersect([
  vComputeMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementPassCountParameters),
  }),
]);

/**
 * Base DTO for creating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vCreateMeasurementBase = v.strictObject({
  id: v.nullish(v.pipe(v.string(), v.uuid())),
  type: v.optional(vMeasurementType),
  name: v.nullish(v.string()),
  attributes: v.nullish(v.record(v.string(), v.string())),
  tags: v.nullish(v.array(v.string())),
});

/**
 * DTO for creating an angle measurement.
 */
export const vCreateMeasurementAngle = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for creating an Area measurement.
 */
export const vCreateMeasurementArea = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for creating a line measurement.
 */
export const vCreateMeasurementLine = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
    result: v.optional(vMeasurementLineResult),
  }),
]);

/**
 * DTO for creating a Pass Count measurement.
 */
export const vCreateMeasurementPassCount = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementPassCountParameters),
    result: v.optional(vMeasurementPassCountResult),
  }),
]);

/**
 * DTO for creating a point measurement.
 */
export const vCreateMeasurementPoint = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for creating a Polyline measurement.
 */
export const vCreateMeasurementPolyline = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
    result: v.optional(vMeasurementPolylineResult),
  }),
]);

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vMeasurementBase = v.strictObject({
  id: v.nullish(v.string()),
  tenantTrn: v.nullish(v.string()),
  type: v.optional(vMeasurementType),
  name: v.nullish(v.string()),
  tags: v.nullish(v.array(v.string())),
  attributes: v.nullish(v.record(v.string(), v.string())),
  createdBy: v.nullish(v.string()),
  createdAt: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  modifiedBy: v.nullish(v.string()),
  modifiedOn: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * DTO for an angle measurement.
 */
export const vMeasurementAngle = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for an Area measurement.
 */
export const vMeasurementArea = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for a line measurement.
 */
export const vMeasurementLine = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.nullish(v.record(v.string(), v.unknown())),
    result: v.optional(vMeasurementLineResult),
  }),
]);

/**
 * DTO for a Pass Count measurement.
 */
export const vMeasurementPassCount = v.intersect([
  vMeasurementBase,
  v.strictObject({
    parameters: v.optional(vMeasurementPassCountParameters),
    result: v.optional(vMeasurementPassCountResult),
  }),
]);

/**
 * DTO for a point measurement.
 */
export const vMeasurementPoint = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for a Polyline measurement.
 */
export const vMeasurementPolyline = v.intersect([
  vMeasurementBase,
  v.strictObject({
    geometry: v.nullish(v.record(v.string(), v.unknown())),
    result: v.optional(vMeasurementPolylineResult),
  }),
]);

/**
 * DTO for the result of a Volume measurement.
 */
export const vMeasurementVolumeResult = v.strictObject({
  netVolume: v.nullish(v.number()),
  totalVolume: v.nullish(v.number()),
  totalCutVolume: v.nullish(v.number()),
  totalFillVolume: v.nullish(v.number()),
  totalBalanceVolume: v.nullish(v.number()),
  totalCutArea: v.nullish(v.number()),
  totalFillArea: v.nullish(v.number()),
  totalCoverageArea: v.nullish(v.number()),
  tilesetUrl: v.nullish(v.string()),
});

/**
 * Response Dto containing the result from computing a volume measurement
 */
export const vComputeMeasurementVolumeResponse = v.intersect([
  vComputeMeasurementResponseBase,
  v.strictObject({
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

/**
 * Represents a link.
 */
export const vPageLinks = v.strictObject({
  self: v.optional(vLink),
  first: v.optional(vLink),
  prev: v.optional(vLink),
  next: v.optional(vLink),
  last: v.optional(vLink),
});

/**
 * Service health
 */
export const vServiceHealth = v.strictObject({
  name: v.nullish(v.string()),
  status: v.optional(vHealthStatus),
  duration: v.nullish(v.string()),
});

export const vTextureType = v.picklist(['Gradient', 'Stepped']);

/**
 * The appearance of a palette. Stop count/order, hex format, and required range colours are
 * enforced by `ColorPaletteSettingsDtoValidator`.
 */
export const vColorPaletteSettings = v.strictObject({
  textureType: v.optional(vTextureType),
  colorAboveRange: v.nullish(v.string()),
  colorBelowRange: v.nullish(v.string()),
  colorOnTarget: v.nullish(v.string()),
  stops: v.nullish(v.array(vColorStop)),
});

/**
 * A colour palette as returned by the API. The palette-ID resolver on the tile render path
 * consumes exactly this shape, so keep it stable.
 */
export const vColorPalette = v.strictObject({
  paletteId: v.optional(v.pipe(v.string(), v.uuid())),
  tenantTrn: v.nullish(v.string()),
  paletteType: v.optional(vColorPaletteType),
  name: v.nullish(v.string()),
  settings: v.optional(vColorPaletteSettings),
  isDefault: v.optional(v.boolean()),
  isDeleted: v.optional(v.boolean()),
  createdBy: v.nullish(v.string()),
  createdAt: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  modifiedBy: v.nullish(v.string()),
  modifiedOn: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * Request body to create a palette. The owning project (tenant) comes from the route/auth context,
 * not the body.
 */
export const vCreateColorPalette = v.strictObject({
  paletteType: v.optional(vColorPaletteType),
  name: v.nullish(v.string()),
  settings: v.optional(vColorPaletteSettings),
  isDefault: v.optional(v.boolean()),
});

/**
 * Represents a paged list.
 */
export const vPagedListColorPalette = v.strictObject({
  pageIndex: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  totalItems: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  items: v.nullish(v.array(vColorPalette)),
  links: v.optional(vPageLinks),
});

/**
 * Request body to update a palette. All fields are optional; `PaletteType` is immutable after
 * create and is therefore not present here.
 */
export const vUpdateColorPalette = v.strictObject({
  name: v.nullish(v.string()),
  settings: v.optional(vColorPaletteSettings),
  isDefault: v.nullish(v.boolean()),
});

/**
 * Base DTO for updating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vUpdateMeasurementBase = v.strictObject({
  type: v.optional(vMeasurementType),
  name: v.nullish(v.string()),
  attributes: v.nullish(v.record(v.string(), v.string())),
  tags: v.nullish(v.array(v.string())),
});

/**
 * DTO for updating an angle measurement.
 */
export const vUpdateMeasurementAngle = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for updating an Area measurement.
 */
export const vUpdateMeasurementArea = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for creating a line measurement.
 */
export const vUpdateMeasurementLine = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
    result: v.optional(vMeasurementLineResult),
  }),
]);

/**
 * DTO for updating a Pass Count measurement.
 */
export const vUpdateMeasurementPassCount = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementPassCountParameters),
    result: v.optional(vMeasurementPassCountResult),
  }),
]);

/**
 * DTO for creating a point measurement.
 */
export const vUpdateMeasurementPoint = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
  }),
]);

/**
 * DTO for updating a Polyline measurement.
 */
export const vUpdateMeasurementPolyline = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    geometry: v.nullish(v.record(v.string(), v.unknown())),
    result: v.optional(vMeasurementPolylineResult),
  }),
]);

export const vVolumeType = v.picklist(['SurfaceToSurface']);

/**
 * DTO for the parameters used for calculating a Volume measurement.
 */
export const vMeasurementVolumeParameters = v.strictObject({
  volumeType: v.optional(vVolumeType),
  fromSurfaceId: v.nullish(v.string()),
  fromSurfaceName: v.nullish(v.string()),
  toSurfaceId: v.nullish(v.string()),
  toSurfaceName: v.nullish(v.string()),
  fromFilterId: v.nullish(v.string()),
  fromFilterName: v.nullish(v.string()),
  toFilterId: v.nullish(v.string()),
  toFilterName: v.nullish(v.string()),
  accountUid: v.nullish(v.pipe(v.string(), v.uuid())),
  projectUid: v.nullish(v.pipe(v.string(), v.uuid())),
  boundaryInclusive: v.nullish(v.record(v.string(), v.unknown())),
  includeTilesetUrl: v.nullish(v.boolean()),
});

/**
 * Dto to compute a volume measurement
 */
export const vComputeMeasurementVolume = v.intersect([
  vComputeMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementVolumeParameters),
  }),
]);

/**
 * DTO for creating a Volume measurement.
 */
export const vCreateMeasurementVolume = v.intersect([
  vCreateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementVolumeParameters),
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

/**
 * DTO for a Volume measurement.
 */
export const vMeasurementVolume = v.intersect([
  vMeasurementBase,
  v.strictObject({
    parameters: v.optional(vMeasurementVolumeParameters),
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

/**
 * Represents a paged list.
 */
export const vPagedListMeasurementBase = v.strictObject({
  pageIndex: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  totalItems: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  items: v.nullish(v.array(v.unknown())),
  links: v.optional(vPageLinks),
});

/**
 * DTO for updating a Volume measurement.
 */
export const vUpdateMeasurementVolume = v.intersect([
  vUpdateMeasurementBase,
  v.strictObject({
    type: v.optional(vMeasurementType),
    parameters: v.optional(vMeasurementVolumeParameters),
    result: v.optional(vMeasurementVolumeResult),
  }),
]);

export const vListColorPalettesPath = v.object({
  tenantTrn: v.string(),
});

export const vListColorPalettesQuery = v.object({
  PaletteType: v.optional(vColorPaletteType),
  PageIndex: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  PageSize: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  SortBy: v.optional(v.string()),
});

/**
 * OK
 */
export const vListColorPalettesResponse = vPagedListColorPalette;

/**
 * The create palette payload.
 */
export const vCreateColorPaletteBody = vCreateColorPalette;

export const vCreateColorPalettePath = v.object({
  tenantTrn: v.string(),
});

/**
 * Created
 */
export const vCreateColorPaletteResponse = vColorPalette;

export const vGetDefaultColorPalettePath = v.object({
  tenantTrn: v.string(),
});

export const vGetDefaultColorPaletteQuery = v.object({
  PaletteType: v.optional(vColorPaletteType),
});

/**
 * OK
 */
export const vGetDefaultColorPaletteResponse = vColorPalette;

export const vDeleteColorPalettePath = v.object({
  tenantTrn: v.string(),
  id: v.pipe(v.string(), v.uuid()),
});

/**
 * No Content
 */
export const vDeleteColorPaletteResponse = v.void();

export const vGetColorPalettePath = v.object({
  tenantTrn: v.string(),
  id: v.pipe(v.string(), v.uuid()),
});

/**
 * OK
 */
export const vGetColorPaletteResponse = vColorPalette;

/**
 * The partial update payload.
 */
export const vUpdateColorPaletteBody = vUpdateColorPalette;

export const vUpdateColorPalettePath = v.object({
  tenantTrn: v.string(),
  id: v.pipe(v.string(), v.uuid()),
});

/**
 * OK
 */
export const vUpdateColorPaletteResponse = vColorPalette;

export const vCheckHealthPath = v.object({
  region: v.string(),
});

/**
 * OK
 */
export const vCheckHealthResponse = v.array(vServiceHealth);

export const vListMeasurementsPath = v.object({
  tenantTrn: v.string(),
});

export const vListMeasurementsQuery = v.object({
  PageIndex: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  PageSize: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        'Invalid value: Expected int32 to be >= -2147483648'
      ),
      v.maxValue(
        2147483647,
        'Invalid value: Expected int32 to be <= 2147483647'
      )
    )
  ),
  SortBy: v.optional(v.string()),
});

/**
 * OK
 */
export const vListMeasurementsResponse = vPagedListMeasurementBase;

/**
 * Base DTO for creating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vCreateMeasurementBody = v.union([
  vCreateMeasurementVolume,
  vCreateMeasurementPolyline,
  vCreateMeasurementPoint,
  vCreateMeasurementPassCount,
  vCreateMeasurementLine,
  vCreateMeasurementArea,
  vCreateMeasurementAngle,
]);

export const vCreateMeasurementPath = v.object({
  tenantTrn: v.string(),
});

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vCreateMeasurementResponse = v.union([
  vMeasurementVolume,
  vMeasurementPolyline,
  vMeasurementPoint,
  vMeasurementPassCount,
  vMeasurementLine,
  vMeasurementArea,
  vMeasurementAngle,
]);

/**
 * Base DTO for creating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vComputeMeasurementBody = v.union([
  vComputeMeasurementVolume,
  vComputeMeasurementPassCount,
]);

export const vComputeMeasurementPath = v.object({
  tenantTrn: v.string(),
});

/**
 * Base Response Dto containing the result from computing a measurement
 */
export const vComputeMeasurementResponse = v.union([
  vComputeMeasurementVolumeResponse,
  vComputeMeasurementPassCountResponse,
]);

export const vDeleteMeasurementPath = v.object({
  tenantTrn: v.string(),
  measurementId: v.pipe(v.string(), v.uuid()),
});

/**
 * No Content
 */
export const vDeleteMeasurementResponse = v.void();

export const vGetMeasurementPath = v.object({
  tenantTrn: v.string(),
  measurementId: v.pipe(v.string(), v.uuid()),
});

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vGetMeasurementResponse = v.union([
  vMeasurementVolume,
  vMeasurementPolyline,
  vMeasurementPoint,
  vMeasurementPassCount,
  vMeasurementLine,
  vMeasurementArea,
  vMeasurementAngle,
]);

/**
 * Base DTO for updating a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vUpdateMeasurementBody = v.union([
  vUpdateMeasurementVolume,
  vUpdateMeasurementPolyline,
  vUpdateMeasurementPoint,
  vUpdateMeasurementPassCount,
  vUpdateMeasurementLine,
  vUpdateMeasurementArea,
  vUpdateMeasurementAngle,
]);

export const vUpdateMeasurementPath = v.object({
  tenantTrn: v.string(),
  measurementId: v.pipe(v.string(), v.uuid()),
});

/**
 * Base DTO for a measurement with common properties. Polymorphic via the 'type' property.
 */
export const vUpdateMeasurementResponse = v.union([
  vMeasurementVolume,
  vMeasurementPolyline,
  vMeasurementPoint,
  vMeasurementPassCount,
  vMeasurementLine,
  vMeasurementArea,
  vMeasurementAngle,
]);
